import { loadModal } from '../../AsyncLoader';
import SyosPageComponent from '../SyosPageComponent';

function getBodyContents(maxSeatCount) {
  return `
    <p>You have reached the maximum number of seats allowed per order (${maxSeatCount}).</p>
    <p>If you would like to change seats, please first remove a seat and try again.</p>
  `;
}

const SyosMaximumSeatsReachedModal = {
  open(syosController) {
    loadModal().then((Modal) => {
      const maxSeatCount = syosController.getMaximumSeatCount();

      Modal.alert({
        root: syosController.$el,
        title: SyosPageComponent.maximumSeatsReachedModalTitle,
        bodyContents: getBodyContents(maxSeatCount),
      });
    });
  },
};

export default SyosMaximumSeatsReachedModal;



// WEBPACK FOOTER //
// ./src/syos/modals/SyosMaximumSeatsReachedModal.js